module.exports = __webpack_public_path__ + "img/logo.2eafab94.png";